import React, {useEffect, useMemo, useState} from "react";
import ReportUtils from "../../../../../utils/report-utils.js";

const UserFill = ({data}) => {
  const [limit, setLimit] = useState(15);
  const passedLimit = data.length > limit;
  const columns = useMemo(() => [
    {key: "user_name", label: "Atendente"},
    {key: "nature", label: "Natureza"},
    {key: "obs", label: "Obs. atendente"},
    {key: "obs_final", label: "Obs. final"},
    {key: "place", label: "Local pré-cadastrado"},
    {key: "street", label: "Logradouro"},
    {key: "number", label: "Número"},
    {key: "neighborhood", label: "Bairro"},
    {key: "sector", label: "Setor"},
    {key: "lat", label: "Latitude/Longitude"}
  ].filter(({key}) => key === "user_name" || data.some(item => Object.hasOwn(item, key))), [data]);

  const fillTable = (obj, idx) =>
    <tr key={idx}>
      {columns.map(({key}) => <td key={key} className="text-left">{obj[key]}</td>)}
    </tr>
  const seeMoreOrLess = () => {
    setLimit(prev => prev ? null : 15);
  };

  useEffect(() => {
    if (data.length === 0) return;

    const values = data.map(obj => columns.map(({key}) => obj[key]));

    ReportUtils.createExportableTable(columns.map(({label}) => label), values, "Índices de preenchimento por atendente");
  }, [data, columns]);

  return(
   <div className="chart-report">
     <span className="chart-title mb-3">Índices de preenchimento por atendente</span>
     <div className="mt-3 mb-3">
       <table  className="table report-table" sheet-name="Índices de preenchimento por atendente">
         <thead className="thead-background table-row-group!">
         <tr>
           {columns.map(({key, label}) => <th key={key} className="text-left">{label}</th>)}
         </tr>
         </thead>
         <tbody>
         {(limit ? data.slice(0, limit) : data).map((el, idx) => fillTable(el, idx))}
         </tbody>
       </table>
       { passedLimit &&
         <div className="text-end mt-1">
                    <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                        {limit ? "Ver mais" : "Ver menos"}
                    </span>
         </div>
       }
     </div>
     <div className="chart-divisor"></div>
   </div>
  )
}

export default UserFill;